import { render } from "./Snowflakes.vue?vue&type=template&id=464f740c&scoped=true"
import script from "./Snowflakes.vue?vue&type=script&lang=js"
export * from "./Snowflakes.vue?vue&type=script&lang=js"

import "./Snowflakes.vue?vue&type=style&index=0&id=464f740c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464f740c"]])

export default __exports__